import { createContext } from 'react'

const AnimationOverlayContext = createContext(null)

export default AnimationOverlayContext
